module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4DeRB"))).then(() => parcelRequire('f4eak'));